import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { AlertController,IonContent,ModalController} from '@ionic/angular';
import { ActivatedRoute,Router } from '@angular/router';
import { PlatformLocation} from '@angular/common';
import { Platform,IonInfiniteScroll } from '@ionic/angular';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { BaseModal } from '../../../../model/base';
import { WebParameterContext } from '../../../../model/common';
import { BaseCase } from '../../../basecase';
import { CommonService } from '../../../../service/common.service';
import {SfaListProductsComponent} from '../../grid/sfa-list-products/sfa-list-products.component';
declare var app;

@Component({
  selector: 'app-sfa-collection-appeal',
  templateUrl: './sfa-collection-appeal.component.html',
  styleUrls: ['./sfa-collection-appeal.component.scss']
})
export class SfaCollectionAppealComponent extends GridBaseCase implements AfterViewInit {
  searchType: number = 0;//搜索类型(门店，分类，地图)
  searchTypeNum: number = 0;//分类筛选（分类筛选中按门店、按人员、按渠道）
  searchTypemendian: number = 0;//门店/经销商
  qudaoNumber: number = null;//渠道
  personNumber: number = null;//人员
  searchVal: string = '';//输入搜索值
  chage: any;
  dataChannelArrayList = [];//获取渠道结果值
  dataPersonArrayList = [];//获取人员结果值
  isFocus:Boolean = false;
  /*------------------------*/
  productArray = [
    { id: 0, name: "产品1", num: 3 },
    { id: 1, name: "产品2", num: 6 },
    { id: 2, name: "产品3", num: 4 },
    { id: 3, name: "产品4", num: 7 },
    { id: 4, name: "产品5", num: 8 },
    { id: 5, name: "产品6", num: 5 }];

  productArray1: any = [
    { id: 6, name: "产品7" },
    { id: 7, name: "产品8" },
  ];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild("mainScrollView") mainScrollView: ElementRef;
  RecordCount: Number = 0;//列表总数量
  appealResultList: Array<any> = [];
  scrollHeight:number = 0;
  isHidden:boolean = true;//隐藏上拉加载
  @ViewChild(IonContent) ionContent: IonContent;
  isHiddenrefresher:boolean = false;//隐藏下拉刷新
  /*------------------------*/
  constructor(
    public alertController: AlertController,
    private platform: Platform,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private http: HttpCustomerService,
    public base: BaseModal,
    public baseService: BaseCase,
    private router: Router,
    public com: CommonService,
    public modal:ModalController,
    private platformlocation:PlatformLocation
  ) { super(); }
  changeSelect(e) {
    // console.log(e.detail.value);
    const id = e.detail.value;
    let that = this;
    this.productArray1.forEach(item => {
      if (item.id == id) {
        let obj = item;
        obj['num'] = 0;
        that.productArray.push(obj);
      }
    })
  }

  inputChangeEvent(checkItem,index,text){
    // console.log(checkItem,"item");
    // if(text=="appealnum"){
    //    if(this.base.GridArrayData[index][text].value>0){
    //     this.base.GridArrayData[index]["isappealdistribution"].value=true;
    //    }
    // }
  }

  SeacherData(arrayData:Array<any>=[]){
    console.log(arrayData);
    const that = this;
    arrayData.forEach(itemtemp=>{
      let tempitem={};
         tempitem["name"]={"value":itemtemp.name,"text":""};
         tempitem["num"]={"value":0,"text":""};
         tempitem["success"]={"value":false,"text":""};
         tempitem["appealnum"]={"value":0,"text":""};
      that.baseService.arrayData.push(tempitem);
    });

  }
  loadMoreData(event) {
    let that = this;
    const l:any = that.RecordCount;
    if (Math.ceil(l / app.RowsPerPage) == that.PageNumber ) {
      that.infiniteScroll.disabled = true;
    } else {
      that.isHidden = false;
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  addProduct(){
    const that = this;
    // console.log(this.select.nativeElement);
    let id = this.activaRouter.snapshot.paramMap.get('id');
    console.log(localStorage.getItem("prodata"));
    localStorage.setItem("productData",JSON.stringify(that.base.GridArrayData));//保存列表数据
    //that.create();
    // this.select.el.open();
    // console.log("num:"+ that.PageNumber);
       const n:any=that.PageNumber;
       const l:any = that.RecordCount;
       localStorage.setItem("RecordCount",l);
       if(Math.ceil(l / app.RowsPerPage) > that.PageNumber  ){
         localStorage.setItem("pagenumberint",n);
       }
        //  that.com.setHistoryUrl();
    // if(that.platformlocation["location"].hash.replace('#','')){
    //   localStorage.setItem("backurl",that.platformlocation["location"].hash.replace('#',''));
    
    // }
    that.com.Go("/tabs/contact/AppealProductsList/"+this.com.getNowDatetime+"/"+id);
  }
 async create(){
   const that=this;
  const modal = await that.modal.create({showBackdrop:true,component: SfaListProductsComponent});
  return await modal.present();
  // modal.onDidDismiss();
  }
  LoadData(PageNumber) {
    let that = this;
    that.isHidden = true;
    if(localStorage.getItem("pagenumberint")){
      PageNumber=parseInt(localStorage.getItem("pagenumberint"))+1;
      localStorage.removeItem("pagenumberint");
    }
    that.PageNumber = PageNumber;
    let gridData:any=that.com.GetStorageKey("productData");//处理产品选择返回时数据问题
    if(gridData){
      //  PageNumber=2;
      console.log(gridData);
      that.base.GridArrayData=gridData;
      that.loading = true;
      that.apiObj['status'] = true;
      localStorage.removeItem("productData");
      that.RecordCount = that.com.GetStorageKey("RecordCount");
      localStorage.removeItem("RecordCount");
    }else{
      
      localStorage.removeItem("RecordCount");
      const OpType = that.activaRouter.snapshot.paramMap.get('type');
      if (PageNumber == 1) {
        that.base.GridArrayData=[];
        that.loading = false;
        that.apiObj['status'] = false;
        that.apiObj['msg'] = '';
      }
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let mId:any = that.activaRouter.snapshot.paramMap.get('id');
      if(mId){
        mId=mId.split('&')[0];
      }
      let body = new WebParameterContext();
      if (that.element.selectItemList.gridViewConfigName) {
        body.ConfigName = that.element.selectItemList.gridViewConfigName;
      }
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = PageNumber;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      // if(mId){
        body.RequestBody = JSON.stringify({ "a_TaskID": mId});
      // }else{
      //   body.RequestBody = JSON.stringify({ "m_FK_SystemUser_ID": that.com.GetAccount.Id, "m_FK_TBStore_ID": that.com.GetStorageKey("tbstore")["ID"], "m_TaskDate": that.com.getNow});
      // }
      
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      that.http.post(app.DEFAULTURL, body).then(data => {
        // console.log(11010101);
        /****判断是否第一页begin****/
        if (PageNumber == 1) {
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        } else {
          that.infiniteScroll.complete();
        }
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
          let arraygrid:Array<any> = that.base.GridArrayData;
          data.Status.Datas.forEach(function (item) {
            let objfield = {};
            that.element.selectItemList.selectItem.forEach((element, index) => {
              if (element.bindingField) {
                objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
              }
            });
            // objfield["inputNum"]={"value": 0, "text": "申诉排面"};
            // objfield["inputSuccess"]={"value": false, "text": "申诉分销"};
            arraygrid.push(objfield);
            // console.log(that.base.GridArrayData[0]["num"]);
            // console.log(that.element.selectItemList.selectItem);
            console.log("列表。。。");
  
          });
          arraygrid.forEach(item=>{
            item.appealnum.value=item.num.value;
          });
          that.base.GridArrayData=arraygrid;
          /****上拉加载数据begin****/
          that.RecordCount = data.Status.RecordCount;
          if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.base.GridArrayData.length) {
            that.infiniteScroll.disabled = true;
          } else {
            that.infiniteScroll.disabled = false;
          }
          /****上拉加载数据end****/
        }
  
      }).catch(error => {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
        that.loading = true;
        console.log(error);
      })
    }
  }

  ngAfterViewInit(){
    let that = this;
    // that.scrollHeight = window.outerHeight - 110;
    // setTimeout(()=>{
    //   that.mainScrollView.nativeElement.style.height = that.scrollHeight + 'px';
    // },100)
    setTimeout(()=>{
      that.scrollEvent();
    },100);
  }
  
  getFocus(e){
    // const that = this;
    // this.isFocus = true;
    // console.log(e.target.value);
    // const currentDomOffsetTop = e.target.offsetTop;
    // const currentDomScrollTop = e.target.scrollTop;
    // const winHeight = document.body.clientHeight;
    // const h = winHeight-currentDomOffsetTop - 260;
    
    // if(h > 0){
    //   // e.target.scrollTop = currentDomScrollTop;
    // }else{
    //   // e.target.scrollTop = currentDomScrollTop + Math.abs(h);
    //   // that.ionContent.getScrollElement().then(ele=>{
    //   //   ele.scrollTop = currentDomScrollTop + Math.abs(h) ;
    //   // })
    // }
  }
  setBlur(e){
    this.isFocus = false;
    // console.log(e.target.value);
  }

  scrollEvent(){
    // const dom = document.getElementById("collectionAppeal");
    // dom.addEventListener("scroll",()=>{
    //   let sTop = dom.scrollTop;
    //   console.log(sTop);
    //   if(sTop < 10){
    //     this.isHiddenrefresher = false;
    //   }else{
    //     this.isHiddenrefresher = true;
    //   }
    // })
  }

}
